module.exports = __webpack_public_path__ + "static/img/clcs.ea2a83cf.png";